import gql from "graphql-tag";
import { graphql } from "react-apollo";

export const loginMutation = gql`
  mutation Login($emailOrUsername: String!, $password: String!) {
    login(emailOrUsername: $emailOrUsername, password: $password) {
      __typename

      sessionToken
      learnerTransferToken

      ... on AuthenticationV2 {
        refreshToken
      }
    }
  }
`;

export const changePasswordMutation = gql`
  mutation changePassword($uid: ID!, $token: String!, $password: String!) {
    changePassword(uid: $uid, token: $token, password: $password) {
      sessionToken
    }
  }
`;

export const changeLearnerPasswordMutation = gql`
  mutation changeLearnerPassword(
    $uid: ID!
    $token: String!
    $password: String!
  ) {
    changeLearnerPassword(uid: $uid, token: $token, password: $password) {
      transferToken
    }
  }
`;

export const confirmEmailMutation = gql`
  mutation confirmEmail($uid: ID!, $token: String!) {
    confirmEmail(uid: $uid, token: $token) {
      sessionToken
    }
  }
`;

export const confirmOtherEmailMutation = gql`
  mutation confirmOtherEmail($uid: ID!, $token: String!) {
    confirmOtherEmail(uid: $uid, token: $token)
  }
`;

export const confirmEmailMutationDecorator = graphql(confirmEmailMutation, {
  props({ mutate }) {
    return {
      confirmEmail(uid, token) {
        return mutate({
          variables: {
            uid,
            token
          }
        });
      }
    };
  }
});

export const getLearnerModeTransferToken = gql`
  mutation GetLearnerModeTransferToken($learnerUid: ID!) {
    learnerModeTransferToken(learnerUid: $learnerUid) {
      transferToken
    }
  }
`;
